import { defineComponent as _defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
import { NcButton } from '@nextcloud/vue'
import { useHotKey } from '@nextcloud/vue/composables/useHotKey'
import { t } from '@nextcloud/l10n'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavigationHeaderTodayButton',
  setup(__props) {

const route = useRoute()
const router = useRouter()

async function today(): Promise<void> {
	// Don't push new route when day didn't change
	if (route.params.firstDay === 'now') {
		return
	}

	const name = route.name!
	const params = {
		...route.params,
		firstDay: 'now',
	}

	await router.push({ name, params })
}

useHotKey('t', () => today())

return { __sfc: true,route, router, today, NcButton, t }
}

})